import { render, staticRenderFns } from "./CytomineImage.vue?vue&type=template&id=8e8a79d4&"
import script from "./CytomineImage.vue?vue&type=script&lang=js&"
export * from "./CytomineImage.vue?vue&type=script&lang=js&"
import style0 from "./CytomineImage.vue?vue&type=style&index=0&id=8e8a79d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports